import React from "react";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormGroupTitle, FormTextField } from "ui/Form";

import {
  CREATE_ROLE_MUTATION,
  GET_ROLES_QUERY_NAME,
} from "graphqlQueries/system";

import { addGroupValidator } from "validators/addGroupValidator";

const initialValues = {
  name: "",
};

const fieldsWithPlaceForError = ["name"];

const AddRoleDialog = (props) => {
  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_ROLE_MUTATION}
      refetchQueries={[GET_ROLES_QUERY_NAME]}
      initialValues={initialValues}
      validationSchema={addGroupValidator}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title="Add role"
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <FormGroupTitle title="Role information" />
      <FormTextField name="name" label="Role name" />
    </DialogFormWithMutation>
  );
};

export default AddRoleDialog;
